import { useNavigate } from 'react-router-dom';
import { PublishedResourceView } from './components/PublishedResourceView';
import { usePublishedResource } from './usePublishedResource';
import type { PublishedKind } from './published.types';

interface PublishedModuleProps {
  kind: PublishedKind;
}

/**
 * Public share page for a prototype (`/p/*`) or artifact (`/a/*`): fetches the
 * resource by slug and renders it full-screen (no app shell). The same module
 * serves both via the `kind` param.
 */
export function PublishedModule({ kind }: PublishedModuleProps): JSX.Element {
  const navigate = useNavigate();
  const { isLoading, error, demoUrl, title, onRetry } = usePublishedResource(kind);

  return (
    <PublishedResourceView
      variant={kind}
      isLoading={isLoading}
      error={error}
      demoUrl={demoUrl}
      title={title}
      onNavigateHome={() => navigate('/')}
      onRetry={onRetry}
    />
  );
}
